import React from 'react';
import _ from 'lodash';
import * as PropTypes from 'prop-types';
import ReactTable from "./ReactTable";
import {getReadinessColumns} from "../RetailerReadiness/readinessConstants";

function getFilteredAccounts(data, activeRetailersOnly, alertData, isKeyAccount, isNonMarketRetailer) {
    const periodWeekEndDates = data.periodReleaseReadiness.periodWeeks.map(periodWeek => periodWeek.endDate);
    return _
        .filter(data.periodReleaseReadiness.accounts,
            account =>
                (!activeRetailersOnly || account.isRetailerActive) &&
                account.isKeyAccount === isKeyAccount &&
                account.isNonMarketRetailer === isNonMarketRetailer
        )
        .map(retailer => {
            return {
                ...retailer,
                periodAbbreviation: data.periodReleaseReadiness.periodAbbreviation,
                periodStartDate: _.min(periodWeekEndDates),
                periodEndDate: _.max(periodWeekEndDates),
                alertData: alertData[String(retailer.retailer.retailerId)]
            }
        })
}

function getTable(accounts, alertIsLoading, outlet) {
    return accounts.length > 0 ? <ReactTable
            filterable
            data={accounts}
            columns={getReadinessColumns(alertIsLoading, outlet)}
            initialState={{sorting: [{id: 'issues', desc: true}]}}
            getTrProps={(rowInfo) => {
                let className = ''
                if (rowInfo && rowInfo.original) {
                    if (!rowInfo.original.isRetailerActive) {
                        className = 'inactive-retailer-row'
                    }
                }
                return {
                    className
                };
            }}
        /> :
        <div className={'key-account-no-data-found'}>{'No Data Found'}</div>;
}

const ReadinessContent = ({data, activeRetailersOnly, alertData, alertIsLoading, outlet}) => {
    const keyAccounts = getFilteredAccounts(data, activeRetailersOnly, alertData, true, false);
    const nonKeyAccounts = getFilteredAccounts(data, activeRetailersOnly, alertData, false, false);
    const nonMarketAccounts = getFilteredAccounts(data, activeRetailersOnly, alertData, false, true);

    return (<div className={'readiness-content'}>
        <div className={'ingest-cards'}>
            <div data-testid={'retailer-data-container'} className={'card'}>
                <span className={'card-title'}>Retailer Data</span>
                <div className={'sub-cards'}>
                    <div className={'card-content'}>
                        <div data-testid={"key-account-retailer-number"} className={'retailer-data key-account-retailer'}>
                            {keyAccounts.length}
                        </div>
                        <div className={'content-label'}>
                            Key Accounts
                        </div>
                    </div>
                    <div className={'card-content'}>
                        <div data-testid={"non-key-account-retailer-number"} className={'retailer-data additional-retailer'}>
                            {nonKeyAccounts.length}
                        </div>
                        <div className={'content-label'}>
                            Non Key Account
                        </div>
                    </div>
                    <div className={'card-content'}>
                        <div data-testid={"other-retailer-number"} className={'retailer-data other-retailer'}>
                            {nonMarketAccounts.length}
                        </div>
                        <div className={'content-label'}>
                            Other
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className={'key-account-container'}>
            <div data-testid={"key-account-table-container"} className={'key-account-retailer-contents'}>
                <div className={'key-account-header'}>{'Key Account Retailers'}</div>
                {getTable(keyAccounts, alertIsLoading, outlet)}
            </div>
            <div data-testid={"non-key-account-table-container"} className={'non-key-account-retailer-contents'}>
                <div className={'key-account-header'}>{'Non Key Account Retailers'}</div>
                {getTable(nonKeyAccounts, alertIsLoading, outlet)}
            </div>
            <div data-testid={"non-market-account-table-container"} className={'non-market-account-retailer-contents'}>
                <div className={'key-account-header'}>{'Other Retailers'}</div>
                {getTable(nonMarketAccounts, alertIsLoading, outlet)}
            </div>
        </div>
    </div>);
};

ReadinessContent.propTypes = {
    activeRetailersOnly: PropTypes.bool,
    data: PropTypes.shape({
        periodReleaseReadiness: PropTypes.object
    }),
    alertData: PropTypes.object,
    alertIsLoading: PropTypes.bool,
    outlet: PropTypes.string,
}

export default ReadinessContent;